import React from 'react';

const Title = (props) => {

    return (
        <div className="title-container">
            <h1 className="main-title">{props.title}</h1>
            <p className="school-name">{props.school}</p>
        </div>
    );

}

export default Title;